import React, { useState, useEffect } from 'react';

//import {MyCardWidget} from '../nodemodules/@patronymus/my_card_widget_react_client/react-js-ui';
import {MyCardWidget} from '@patronymus/my_card_widget_react_client/react-js-ui';

import PrimusMoneyDidWidgetService from '../model/did-widget-service.js';

const PresentationWidget = ({widget_client_id, did_widget_params, remote_widget_params_endpoint, lastchangeon}) => {

	const [last_change_on, setLastChangeOn] = useState(Date.now());

	const onWidgetLoaded = async (ev) => {
		console.log('onWidgetLoaded called');
	
		try {
			let data = ev.detail;
			let _widget_client_uuid = (data ? data.widget_client_uuid : null);
			let _widget_client_name = (data ? data.widget_client_name : null);

			console.log('listener for widget_client_id = ' + widget_client_id + ' called by ' + _widget_client_name);
			if (widget_client_id === _widget_client_name) {
				const did_obj = PrimusMoneyDidWidgetService.getObject(_widget_client_name);
				const widget_client = did_obj.getWidgetClient();
				const widget_version_info = await widget_client.getWidgetVersionInfo();
	
				console.log('version info is: ' + JSON.stringify(widget_version_info));
	
			}
	
		}
		catch(e) {
			console.log('exception in onWidgetLoaded: ' + e);
		}
	}

	const _loadComponent = async () => {
		try {
			// iframe not loaded yet, widget client is not created
			if (widget_client_id) {
				console.log('adding listener for widget_client_id = ' + widget_client_id);
				window.addEventListener('mywidgetclient_on_widget_loaded', onWidgetLoaded, false);
			}
		}
		catch(e) {
			console.log('exception in _loadComponent: ' + e);
		}
	};

	// componentDidMount
	useEffect(() => {
		_loadComponent().catch(err => {});
	}, []); // end of useEffect

	// componentDidUpdate
	useEffect(() => {
		setLastChangeOn(lastchangeon);
	}, [lastchangeon]); // end of useEffect
	

	return (
		<MyCardWidget 
			className={'MyDidWidgetContainer'}
			widget_client_id={widget_client_id}
			params = {did_widget_params}
			remote_params_endpoint = {remote_widget_params_endpoint}
			key = {widget_client_id + '_' + last_change_on}
		/>
	);
}


export default PresentationWidget;